module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"confirmEmail":"Confirm e-mail address","confirmingEmail":"Confirming e-mail address","notConfirmed":"Cannot verify e-mail address","resend":"Resend","verificationSent":"Verification e-mail sent"}}')
  delete Component.options._Ctor
}
